export default "__VITE_ASSET__BlE807ml__"